import React from "react";

const HeroSkeleton = () => {
  return (
    <div className="relative h-screen w-full bg-gray-800 animate-pulse overflow-hidden">
      <div className="absolute inset-0 bg-black/60"></div>

      <div className="relative z-10 flex items-center justify-center h-full">
        <div className="flex flex-col w-full px-5 items-center gap-4">
          <div className="h-[25px] w-[260px] md:w-full bg-gray-600 rounded"></div>
          <div className="h-[24px] w-[200px] md:w-[300px] bg-gray-600 rounded"></div>
          <div className="h-[40px] w-[160px] bg-gray-600 rounded mt-4"></div>
        </div>
      </div>
    </div>
  );
};

export default HeroSkeleton;
